import * as React from 'react';
/**
 *
 * Original name: available
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=20530%3A2411
 *
 */
export const AvailableSync = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Z", fill: "#fff", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m9.061 11 1.97 1.97L15 9l1.061 1.061-5.03 5.03L8 12.061 9.061 11Z", fill: "#00864C", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12c0-5.159 2.841-8 8-8s8 2.841 8 8-2.841 8-8 8-8-2.841-8-8Zm1.5 0c0 4.374 2.126 6.5 6.5 6.5 4.374 0 6.5-2.126 6.5-6.5 0-4.374-2.126-6.5-6.5-6.5-4.374 0-6.5 2.126-6.5 6.5Z", fill: "#00864C", vectorEffect: "non-scaling-stroke" })));
